export default "__VITE_ASSET__Ca6avwJZ__"